import { DataBox } from "./DataBox";
import { threeInspectionSchedulingModel } from "../schedulingModel";
import { PageHeader } from "./PageHeader";
import { AddSchedulingModal } from "./addSchedulingModal";
import { EditSchedulingModal } from "./editSchedulingModal";

export function ThreeInspectionScheduling() {
    const { addCarVisible, editCarVisible, } = threeInspectionSchedulingModel();
    return (
        <>
            <PageHeader />
            <DataBox />
            {addCarVisible && <AddSchedulingModal />}
            {editCarVisible && <EditSchedulingModal />}
        </>
    );
}

